export const invoiceStatusList = [
  "Paid",
  "Pricing",
  "Reviewed",
  "Sent",
  "Unreviewed",
];

export const orderStatusList = [
  "AnalyticalComplete",
  "AnalyticalPending",
  "ApprovedForRelease",
  "Cancelled",
  "Complete",
  "InterpretationReview",
  "Invoiced",
  "KitRegistered",
  "OrderRequestHold",
  "Paid",
  "Pricing",
  "Received",
  "Reported",
  "ResolutionPending",
  "Review",
  "ReviewPending",
  "Shipped",
];

export const userRouteStatusList = [
  "Completed",
  "Not Completed",
];

export const waterProfileStatusList = [
  "Active",
  "Non Active",
];

export const bottleOrderStatusList = [
  "Pending",
  "Prepared",
  "Approved",
  "Kit Built",
  "Kit Reviewed",
  "Packed to Ship",
  "Shipped",
  "Partially Received",
  "Received",
  "On Hold",
  "Cancelled",
];


export const bottleOrderStatusListOld = [
  "Prepared",
  "Pending",
  "Shipped",
  "Received",
  "Cancelled",
];


// New list for Order Type
export const orderTypeList = [
  "Not Specified",
  "Drinking Water",
  "Drinking Water NonReg",
  "Waste Water",
  "IndoorPool",
  "OutdoorPool",
  "Multiple",
  "ETK",
  "ETK Distributor",
  "ETK Wholesale",
  "BathingBeach",
  "PoolManagement",
];

export const quoteStatusList = [
  "Pending",
  "Prepared",
  "OnHold",
  "Reviewed",
  "Sent",
  "PricingUpdated",
  "Approved",
  "Rejected",
  "Expired",
];
export const outsourcedAnalysisStatusList = [
  "Approved",
  "Non-Approved",
];

export const temperatureEquipmentTypeList = [
  "Incubator",
  "Refrigerator",
  "Freezer",
  "Oven",
];

// Supply order workflow (ENB-566). Order here is the intended progression -
// the UI offers all of them, it does not force the sequence.
export const supplyOrderStatusList = [
  "Pending",
  "Review Needed",
  "Approved",
  "Submitted",
  "Deposit Paid",
  "Waiting on Final Payment",
  "Paid",
  "Shipped",
  "Received Partially",
  "Received in Full",
  "QC Required",
  "Released",
  "Closed",
  "Cancelled",
];

export const supplyOrderPriorityList = ["Standard", "Elevated", "Urgent"];

export const supplyOrderTypeList = ["Production", "Shipment"];

// Inventory product configuration (ENB-568). Kept here rather than in lookup
// tables so the module needs no extra API calls to render a form.
export const inventoryOrderLevelList = [
  "Case",
  "Each",
];

// Vendor classification (ENB-567, per Ryan 2026-09-18).
export const vendorTypeList = [
  "Lab",
  "ETK",
  "Lab and ETK",
];
